export const required = value => value ? undefined : 'This field is required.';
export const minLength2 = value => value && value.toString().length < 2 ? `Please enter at least 2 characters.` : undefined;
export const minLength5 = value => value && value.toString().length < 5 ? `Please enter at least 5 characters.` : undefined;
export const maxLength16 = value => value && value.toString().length > 16 ? `This field can have maximum 16 characters.` : undefined;
export const lengthBetween6And8 = value => value && (value.toString().length < 6 || value.toString().length > 9) ? `This field should be between 6 and 9 characters.` : undefined;
export const numeric = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;



// WEBPACK FOOTER //
// ./src/components/RequestForm/validations.js